<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: 'SearchBuild',

  data() {
    return {
      buildNotFound: false,
      buildIsSearching: false,
      buildUid: '',
    }
  },

  computed: {
    ...mapGetters({
      isMagento: 'preference/isMagento',
    }),
  },

  methods: {
    async searchBuild() {
      this.buildIsSearching = true;
      this.buildNotFound = false;

      try {
        const {data} = await axios.post('search-build', {
          buildUid: this.buildUid,
        });

        await this.selectBuild(data.name);
      } catch (e) {
        this.buildNotFound = true;
      } finally {
        this.buildIsSearching = false;
      }
    },
    /**
     * @param {string} buildTypeName
     */
    async selectBuild(buildTypeName) {
      let routeName = null;

      switch (buildTypeName) {
        case 'powerpack':
          routeName = this.isMagento ? 'powerpack-generator' : 'powerpack-configurator';
          this.$router.push({
            name: routeName,
            query: {
              build: this.buildUid,
            }
          });
          break;
        case 'hose':
          routeName = 'slang-configurator';
          this.$router.push({
            name: routeName,
            query: {
              slang: this.buildUid,
            }
          });
          break;
        case 'motorconfig':
          routeName = 'motor-configurator';
          this.$router.push({
            name: routeName,
            query: {
              build: this.buildUid,
            }
          });
          break;
        default:
          throw new Error('Build not found');
      }

      this.$emit('close');
    },
  }
}
</script>

<template>
  <div class="search-build">
    <span>{{ $t('powerpack.steps.step1.build_code') }}</span>

    <div class="input-group flex-nowrap">
      <input
          type="text"
          v-model="buildUid"
          class="form-control"
          id="search-build"
      />
      <button
          class="btn btn-primary ml-1"
          :disabled="buildIsSearching"
          :class="{'disabled': buildIsSearching}"
          @click="searchBuild"
      >
        {{ $t('general.search') }}
      </button>
    </div>

    <small v-if="buildNotFound" class="text-danger">{{ $t('splash.build.notFound') }}</small>
  </div>
</template>

<style scoped lang="scss">
.search-build {

  input {
    max-width: 200px;
    border-radius: 50px !important;
    border: 2px solid #EBEBEB;

    &:focus {
      outline: none !important;
      box-shadow: none;
      border-color: #EBEBEB;
    }
  }

  .title {
    font-size: 20px;
  }

  .btn {
    padding: 5px 30px !important;
  }
}
</style>
